import { __rest, __read, __assign } from './../../external_lib/tslib/tslib.es6.js';
import classNames from './../../external_lib/classnames/index.js';
import React__default, { useState } from 'react';
import styles from '../../components/base/HorizonSingleSelect/index.module.scss.js';
import Cancel from '../../assets/icons/jsx/Cancel.js';
import ChevronDown from '../../assets/icons/jsx/ChevronDown.js';
import Checked from '../../assets/icons/jsx/Checked.js';
import AntSelect from './../../external_lib/antd/es/select/index.js';
function HorizonSingleSelect(_a) {
  var children = _a.children,
    className = _a.className,
    popupClassName = _a.popupClassName,
    allowClear = _a.allowClear,
    restProps = __rest(_a, ["children", "className", "popupClassName", "allowClear"]);
  var _b = __read(useState(false), 2),
    open = _b[0],
    setOpen = _b[1];
  return React__default.createElement(AntSelect, __assign({
    rootClassName: classNames(styles.horizonSingleSelect, className),
    popupClassName: classNames(popupClassName, 'p-0'),
    allowClear: allowClear && {
      clearIcon: React__default.createElement(Cancel, null)
    },
    menuItemSelectedIcon: React__default.createElement(Checked, null),
    suffixIcon: React__default.createElement(ChevronDown, {
      style: {
        transform: open ? 'rotate(180deg)' : 'rotate(0deg)'
      },
      className: classNames(open && 'text-up-blue-40', 'transition-transform origin-center ease-in-out duration-300')
    }),
    onDropdownVisibleChange: function (open) {
      return setOpen(open);
    }
  }, restProps), children);
}
HorizonSingleSelect.Option = AntSelect.Option;
export { HorizonSingleSelect as default };
//# sourceMappingURL=index.js.map
